import { Redirect } from "react-router-dom";

const RedirectRoute = (props) => {
  return <>{<Redirect to="/board/root" />}</>;
};

export default RedirectRoute;
